var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLearningVideo = function SvgLearningVideo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V15C24 17.2091 22.2091 19 20 19H4C1.79086 19 0 17.2091 0 15V4ZM4 2C2.89543 2 2 2.89543 2 4V15C2 16.1046 2.89543 17 4 17H20C21.1046 17 22 16.1046 22 15V4C22 2.89543 21.1046 2 20 2H4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3714 17.0715C10.8842 17.2766 11.1336 17.8586 10.9285 18.3714L8.92848 23.3714C8.72336 23.8842 8.14139 24.1336 7.62861 23.9285C7.11583 23.7234 6.86641 23.1414 7.07152 22.6286L9.07152 17.6286C9.27664 17.1158 9.85861 16.8664 10.3714 17.0715Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6286 17.0715C13.1158 17.2766 12.8664 17.8586 13.0715 18.3714L15.0715 23.3714C15.2766 23.8842 15.8586 24.1336 16.3714 23.9285C16.8842 23.7234 17.1336 23.1414 16.9285 22.6286L14.9285 17.6286C14.7234 17.1158 14.1414 16.8664 13.6286 17.0715Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.5938 8.7462C15.1354 9.06651 15.1354 9.93349 14.5938 10.2538L10.1201 12.8998C9.61187 13.2004 9 12.7886 9 12.146V6.85402C9 6.21139 9.61187 5.79962 10.1201 6.10023L14.5938 8.7462Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLearningVideo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/learning-video.e94b6e878941f1cc25e598ad23f1163c.svg";